export default "__VITE_ASSET__a0555bf4__"